import actions from './action'

const initialState = {
  data: [],
  celebrations: [],
  categories: [],
}

const fetchEventsData = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_EVENT_DATA:
      return {
        ...state,
        data: action.payload,
      }

    case actions.FETCH_CELEBRATION_DATA:
      return {
        ...state,
        celebrations: action.payload,
      }

    case actions.FETCH_EVENT_CATEGORIES:
      return {
        ...state,
        categories: action.payload,
      }

    default:
      return state
  }
}

export default fetchEventsData
